import type {
  AddMultiValueSlotAction,
  AddNodeAction,
  ChangeNodeTypeIdAction,
  MoveNodeAction,
  RemoveLanguageAction,
  RemoveNodeAction,
  ReorderNodeAction,
  ReplaceNodeAction,
  SetOwnerAction,
  SetRoleAction,
  UpdateNodeConfigAction,
  UpdateVersionsAction,
} from "../../schemas/index.ts";
import { createNodeDesignsAction } from "./shared.ts";

export const addNodeAction = createNodeDesignsAction<AddNodeAction>("ADD");

export const updateNodeConfigAction = createNodeDesignsAction<UpdateNodeConfigAction>("UPDATE_CONFIG");

export const removeNodeAction = createNodeDesignsAction<RemoveNodeAction>("REMOVE");

export const replaceNodeAction = createNodeDesignsAction<ReplaceNodeAction>("REPLACE");

export const reorderNodeAction = createNodeDesignsAction<ReorderNodeAction>("REORDER");

export const updateVersionsAction = createNodeDesignsAction<UpdateVersionsAction>("UPDATE_VERSIONS");

export const moveNodeAction = createNodeDesignsAction<MoveNodeAction>("MOVE");

export const addMultiValueSlot = createNodeDesignsAction<AddMultiValueSlotAction>("ADD_MULTI_VALUE_SLOT");

export const changeNodeTypeId = createNodeDesignsAction<ChangeNodeTypeIdAction>("CHANGE_TYPE_ID");

export const setNodeRoleAction = createNodeDesignsAction<SetRoleAction>("SET_ROLE");

export const setOwnerAction = createNodeDesignsAction<SetOwnerAction>("SET_OWNER");

export const removeLanguageAction = createNodeDesignsAction<RemoveLanguageAction>("REMOVE_LANGUAGE");
